import React, { Component } from 'react'
import { connect } from 'react-redux'

import { MultiMenuTrigger } from '@protonapp/react-multi-menu'

import {
  getComponent,
  getCurrentAppId,
  updateObject,
} from 'ducks/editor/objects'
import { getApp } from 'ducks/apps'
import {
  getDefaultDatasource,
  getDatasourcesObject,
} from 'ducks/apps/datasources'
import Icon from 'components/Shared/Icon'
import { GroupedAccordion } from 'components/Shared/Accordion'

import { getCollection } from 'utils/datasources'

import { SortableFieldItemsList } from './Field'
import { parseTableFields } from './utils'

import ListControl from '../../ListControl'
import { THEMES } from '../../../../../constants'

class Table extends Component {
  parseColumns = () => {
    const { object } = this.props
    const { fields } = object

    return fields.map(field => ({
      type: field.type,
      label: field.label,
      fieldId: field.fieldId,
    }))
  }

  update = changes => {
    const { object, updateObject } = this.props

    updateObject(object.id, changes)
  }

  handleSort = ({ oldIndex, newIndex }) => {
    const { object } = this.props
    const { fields } = object

    const [removedField] = fields.splice(oldIndex, 1)

    fields.splice(newIndex, 0, removedField)

    this.update({ fields })
  }

  handleDelete = index => {
    const { object } = this.props
    const { fields } = object

    fields.splice(index, 1)

    this.update({ fields })
  }

  handleAdd = field => {
    const { object, datasource } = this.props
    const { fields, collection } = object

    const tableFields = datasource.tables[collection.tableId].fields

    const tableField = tableFields[field]

    fields.push({
      fieldId: field,
      label: tableField.name,
      type: tableField.type,
    })

    this.update({ fields })
  }

  getFields = () => {
    const { datasource, object } = this.props
    const { collection, fields } = object

    const tableFields = datasource.tables[collection.tableId].fields

    const filteredFields = Object.keys(tableFields).filter(
      tableFieldId =>
        fields.findIndex(field => field.fieldId === tableFieldId) === -1
    )

    return filteredFields.map(tableFieldId => {
      const tableField = tableFields[tableFieldId]
      const icon = tableField.type === 'password' ? 'text' : tableField.type

      return {
        key: tableFieldId,
        label: tableField.name,
        value: tableFieldId,
        icon,
      }
    })
  }

  render() {
    const { object, appId, componentId, datasourceCollection, datasource } =
      this.props

    return (
      <g>
        <ListControl
          key="table-control"
          listTitle="Table Data"
          datasource={datasource}
          includeFields
          hideActions
          hideComponents
          hideColumnSpacing
          hideAdvancedOptions
          {...this.props}
        />
        {object.fields && (
          <GroupedAccordion
            className="library-inspect-accordion"
            group="form-inspect"
            title="Columns"
            renderChildren={() => (
              <div>
                <div className="form-inspect-fields-section">
                  <p className="form-inspect-fields-title">Table Columns</p>
                  <SortableFieldItemsList
                    items={this.parseColumns()}
                    collection={datasourceCollection}
                    datasource={datasource}
                    appId={appId}
                    componentId={componentId}
                    object={object}
                    onDelete={this.handleDelete}
                    onSortEnd={this.handleSort}
                    distance={5}
                  />
                  <MultiMenuTrigger
                    className="form-inspect-add-field"
                    menu={this.getFields}
                    onSelect={this.handleAdd}
                    menuTheme={THEMES.DATA}
                  >
                    <Icon type="plus" />
                    <span>Add Column</span>
                  </MultiMenuTrigger>
                </div>
              </div>
            )}
          />
        )}
      </g>
    )
  }
}

const mapStateToProps = (state, { object }) => {
  const appId = getCurrentAppId(state)
  const app = getApp(state, appId)
  const component = getComponent(state, object.id)

  const dataBindings = object?.dataBinding?.source

  const tableId = dataBindings?.tableId
  const datasource = getDefaultDatasource(state, appId)

  const collection = {
    tableId,
    datasourceId: dataBindings?.datasourceId,
  }

  const datasourceCollection = getCollection(datasource, collection)

  let fields = []

  if (object.fields && !Array.isArray(object.fields)) {
    fields = parseTableFields(object.fields)
  }

  return {
    app,
    appId,
    componentId: component.id,
    datasources: getDatasourcesObject(state, appId),
    datasource,
    object: {
      ...object,
      fields: fields.length > 0 ? fields : object.fields,
      collection,
    },
    datasourceCollection,
  }
}

export default connect(mapStateToProps, { updateObject })(Table)
